import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as _moment from 'moment';
import { UntypedFormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateFormatterService } from '../../providers/date.formatter/date.formatter.service';
import { RunTypeValue } from '../../../lib/services/test-list/types';
import { CommonRegEx } from '../../../lib/validators/match.pattern.validator';

const moment = _moment;

export interface SchedulerFormat {
  timeStamp: string;
  repeatInterval: number;
  endTime: any;
  isValid: boolean;
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY'
  }
};
@Component({
  selector: 'viavi-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }]
})
export class SchedulerComponent implements OnInit, AfterViewInit {
  @ViewChild('inputDate') inputDate: ElementRef;
  @Input() scheduleValue: SchedulerFormat;
  @Input() isDisabledScheduler: boolean;
  // eslint-disable-next-line
  @Input() schedulerEnds: any;
  @Input() minDuration?: number = 1;
  @Output() schedulerDataVal: EventEmitter<SchedulerFormat> = new EventEmitter();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dateChange: EventEmitter<MatDatepickerInputEvent<any>> = new EventEmitter();
  validTestDurationRegex: RegExp = CommonRegEx.HH_MM_SS_REGEX;
  addingColonTwoCharRegex: RegExp = CommonRegEx.COLON_TWO_CHARACTORS;
  date = new UntypedFormControl('');
  selected = 0;
  time = '';
  validTime = true;
  dateValid = true;
  minDate = new Date();
  runType = RunTypeValue;
  // eslint-disable-next-line
  endScheduleVal: any = null;
  customScheduleEnds;
  isvalidCustomDuration = true;
  customDurationErrorMsg = null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  repeatList: any[] = [
    { name: 'Never', value: 0 },
    { name: 'Every 15 minutes', value: 900 },
    { name: 'Every 30 minutes', value: 1800 },
    { name: 'Every hour', value: 3600 },
    { name: 'Every day', value: 86400 },
    { name: 'Every week', value: 604800 }
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  durationOptionsList: any[] = [{ name: 'Never', value: this.runType.ON_GOING }];

  constructor(readonly cd: ChangeDetectorRef, readonly dateFormatter: DateFormatterService) {}

  ngOnInit() {
    this.time = new Date().getHours() + ':' + new Date().getMinutes();
    this.durationOptionsList =
      this.schedulerEnds?.optionsList?.length > 0
        ? this.schedulerEnds.optionsList
        : this.durationOptionsList;
  }

  ngAfterViewInit() {
    this.initializeScheduler();
  }

  initializeScheduler(): void {
    if (this.scheduleValue && this.scheduleValue.timeStamp) {
      const dateObj = this.dateFormatter.getDate(this.scheduleValue.timeStamp, 'YYYY-MM-DD');
      this.time = this.dateFormatter.getTime(this.scheduleValue.timeStamp, 'HH:mm');
      this.date = new UntypedFormControl(moment(dateObj));
    } else {
      if (this.inputDate) {
        this.inputDate.nativeElement.value = 'Now';
      }
    }
    if (this.isDisabledScheduler && this.inputDate) {
      this.inputDate.nativeElement.disabled = true;
      this.inputDate.nativeElement.backgroundColor = 'red';
    }
    if (this.scheduleValue && this.scheduleValue.repeatInterval) {
      if (this.scheduleValue.repeatInterval == 300) {
        //We can remove this check when we don't have every 5 mins test in deployed environemnt
        this.repeatList.splice(1, 0, { name: 'Every 5 minutes', value: 300 });
        this.repeatList.join();
      }
      this.selected = this.scheduleValue.repeatInterval;
    } else {
      this.selected = 0;
    }
    if (this.schedulerEnds?.enabled) {
      this.updateSchedulerEndsList(this.selected);
      if (this.scheduleValue && this.scheduleValue.endTime) {
        this.checkCustomDuration(this.scheduleValue.endTime);
      }
    }

    this.cd.detectChanges();
    this.emitSchedulerValue();
  }

  emitSchedulerValue(): void {
    const data: SchedulerFormat = this.fetchSchedureData();
    this.schedulerDataVal.emit(data);
  }

  onDateChange(): void {
    this.validTime = true;
    this.checkForDate(this.date.value, this.inputDate.nativeElement.value);
    this.time =
      this.getTime(new Date().getHours().toString()) +
      ':' +
      this.getTime(new Date().getMinutes().toString());
    this.emitSchedulerValue();
  }

  fetchSchedureData(): SchedulerFormat {
    let dateTimeData: string;
    let validDuration = false;
    if (this.date?.value) {
      const selDateTime = new Date(
        this.date.value.year(),
        this.date.value.month(),
        this.date.value.date(),
        +this.time.split(':')[0],
        +this.time.split(':')[1]
      ).getTime();
      dateTimeData = selDateTime.toString();
    }
    let scheduleDuration = this.endScheduleVal;
    if (this.endScheduleVal === 'custom') {
      scheduleDuration = this.getTimeDurationInSeconds();
    }
    validDuration = this.schedulerEnds?.enabled ? this.isvalidCustomDuration : true;
    const schedulerFormat: SchedulerFormat = {
      timeStamp: dateTimeData ? dateTimeData : 'now',
      repeatInterval: this.selected,
      endTime: scheduleDuration,
      isValid: this.validTime && this.dateValid && validDuration
    };
    return schedulerFormat;
  }

  resetScheduler(): void {
    this.selected = 0;
    this.date = new UntypedFormControl('');
    this.cd.detectChanges();
    this.inputDate.nativeElement.value = 'Now';
    this.dateValid = true;
    this.emitSchedulerValue();
  }

  getTime(data: string): string {
    if (data && data.toString().length === 1) {
      return '0' + data;
    } else {
      return data.toString();
    }
  }

  editTime(): void {
    const patternForTimeFormat = /^([0-1]?[0-9]|2[0-3]):([0-5]?[0-9])$/;
    this.validTime = true;
    if (!patternForTimeFormat.test(this.time)) {
      this.validTime = false;
    } else if (moment().isSame(this.date.value, 'days') && !this.validateTime(this.time)) {
      this.validTime = false;
    }
    this.emitSchedulerValue();
  }

  editedTimeFormat(): void {
    if (this.validTime) {
      const timeValue = this.time?.split(':');
      this.time = this.getTime(timeValue[0]) + ':' + this.getTime(timeValue[1]);
      this.emitSchedulerValue();
    }
  }

  validateTime(time: string): boolean {
    const valid =
      +time.split(':')[0] > new Date().getHours()
        ? true
        : +time.split(':')[0] === new Date().getHours()
        ? +time.split(':')[1] >= new Date().getMinutes()
        : false;
    return valid;
  }

  checkForDate(dateVal: Date, inputData: string): boolean {
    if (!dateVal) {
      if (inputData.toLowerCase() !== 'now') {
        this.dateValid = false;
        return true;
      }
    } else {
      if (moment().diff(dateVal, 'days') > 0) {
        this.dateValid = false;
        return true;
      }
    }
    this.dateValid = true;
    return false;
  }

  checkPrevDate(data: Date): boolean {
    return moment().diff(data, 'days') > 0 ? true : false;
  }

  changeRepeat(): void {
    this.updateSchedulerEndsList(this.selected);
    if (this.schedulerEnds?.enabled && this.endScheduleVal === 'custom') {
      this.customScheduleEndsChange();
    } else {
      this.emitSchedulerValue();
    }
  }

  onEndScheduleValChange(endVal: string): void {
    this.endScheduleVal = endVal;
    if (endVal === 'custom') {
      this.customScheduleEndsChange();
    } else {
      this.isvalidCustomDuration = true;
      this.emitSchedulerValue();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
  reformatTestDuration(event: any) {
    if (event.data && event.target.value.length < 8) {
      event.target.value = event.target.value.replace(this.addingColonTwoCharRegex, '$1:');
    }
  }

  customScheduleEndsChange(): void {
    let durationinSeconds = null;
    this.customDurationErrorMsg = null;
    this.isvalidCustomDuration = false;
    if (this.customScheduleEnds?.length === 8) {
      durationinSeconds = this.getTimeDurationInSeconds();
      if (this.selected !== 0) {
        if (durationinSeconds >= this.selected) {
          this.isvalidCustomDuration = false;
          this.customDurationErrorMsg = 'Duration should be less than repeats value';
        } else {
          this.isvalidCustomDuration = true;
        }
      } else if (
        durationinSeconds < this.minDuration ||
        !this.customScheduleEnds.match(this.validTestDurationRegex)
      ) {
        this.isvalidCustomDuration = false;
        this.customDurationErrorMsg = `Valid format is: HH:MM:SS where HH is 0-24, MM and SS are 0-59.  The minimum value is ${this.minDuration} sec, maximum is 24 hours.`;
      } else {
        this.isvalidCustomDuration = true;
      }
    }
    this.emitSchedulerValue();
  }

  getTimeDurationInSeconds(): number {
    let duration = null;
    if (this.customScheduleEnds?.length === 8) {
      const hms = this.customScheduleEnds.split(':');
      if (hms.length === 3) {
        const hours = parseInt(hms[0], 10);
        const minutes = parseInt(hms[1], 10);
        const seconds = parseInt(hms[2], 10);
        duration = Number(hours) * 60 * 60 + Number(minutes) * 60 + seconds;
      }
    }
    return duration;
  }

  updateSchedulerEndsList(duration: number): void {
    if (this.schedulerEnds?.enabled) {
      if (duration) {
        this.durationOptionsList = this.schedulerEnds?.optionsList.filter(
          opt =>
            typeof opt.value === 'string' || (typeof opt.value !== 'string' && opt.value < duration)
        );
      } else if (duration === 0) {
        this.durationOptionsList = this.schedulerEnds?.optionsList;
      }
      this.endScheduleVal = this.durationOptionsList[0].value;
    }
  }

  checkCustomDuration(duration: number): void {
    if (typeof duration === 'number' && this.schedulerEnds?.optionsList.length > 0) {
      const isCustomDuration = !this.schedulerEnds?.optionsList.find(
        option => option.value === duration
      );
      if (isCustomDuration) {
        this.endScheduleVal = 'custom';
        this.customScheduleEnds = this.toTimeString(duration);
      } else {
        this.endScheduleVal = duration;
      }
    }
  }

  toTimeString(totalSeconds: number): string {
    const totalMs = totalSeconds * 1000;
    const result = new Date(totalMs).toISOString().slice(11, 19);
    return result;
  }
}
